import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M36 90q0-52 64-52t64 52v30q-6-4-12 2-8 20-4 46-14-14-22-12-6 12-10 26-8-16-16-14-8-2-16 14-4-14-10-26-8-2-22 12 4-26-4-46-6-6-12-2Z" }, null, -1),
    _createElementVNode("circle", {
      cx: "78",
      cy: "90",
      r: "9",
      fill: "var(--mc-avatar)"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "122",
      cy: "90",
      r: "9",
      fill: "var(--mc-avatar)"
    }, null, -1)
  ]))]))
}
export default { render: render }